/* SCROLL NAV POLISH */

export function initScrollPolish() {
  const nav = document.querySelector('.nav');
  if (!nav) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 80) {
      nav.style.padding   = '8px 24px';
      nav.style.boxShadow = '0 4px 24px rgba(0,0,0,0.25)';
    } else {
      nav.style.padding   = '';
      nav.style.boxShadow = '';
    }
  }, { passive: true });
}


